import type { ApiOptions } from './hub-api-request';

import * as React from 'react';

import useApiCallable from './use-api-callable';

/**
 * Hook providing a `reader` matching the `api-read-hook` spec
 */
export default function useReader() {
  const callApi = useApiCallable();
  return React.useCallback(
    async function reader<T>(
      path: string,
      options: ApiOptions = {}
    ): Promise<T> {
      const response = await callApi<T>(path, options);
      return response.data;
    },
    [callApi]
  );
}
